import React, { Component } from 'react';
import PropTypes from 'prop-types';
import Radium from 'radium'
import { Link } from 'react-router'
import { semanticColors } from '../../../Globals/styles';
import { renderOverAllocation } from '../../../Util/overAllocation';
import { simpleDate } from '../../../Util/dateTime';

/*cant style Link workaround
https://github.com/reactjs/react-router/issues/1568*/
var RadiumLink = Radium(Link)

class FrontInsights extends Component {
  render () {
    const { projectId, projectName, projectNumber, showBack, updateFavorite,
      favorite, insights, projectStatus, lastUpdate, overAllocation } = this.props;

    var starclass = favorite ? "fa fa-star" : "fa fa-star-o"
    return (
    <div style={styles.body} id={projectId + 'bodyfront'}>
      <i  className={starclass}
          style={styles.defaultStar}
          onClick={()=>updateFavorite(!favorite)}
      />
      <RadiumLink
        to={"/tilbud/sag/"+ projectNumber}
        style={styles.title}
      >
      <div  className="btn btn-primary waves-btn"
            style={[styles.cardHeader,
                    projectStatus===1 && styles.outDated,
                    projectStatus===2 && styles.overAllocation
                  ]}>
                    <div>{projectNumber}</div>
                    <div>{projectName}</div>
      </div>
      </RadiumLink>
      <div  className="col-xs-12" style={styles.cardBody}>
        <div className="row" style={styles.hoursContainer}>
          <div style={styles.label}>Estimeret</div>
          <div style={styles.hours}>{insights.estimatedSum}</div>
        </div>
        <div className="row" style={styles.hoursContainer}>
          <div style={styles.label}>Udført</div>
          <div style={styles.hours}>{insights.totalHours} - {isNaN(insights.percent) ? 0 : insights.percent}%</div>
        </div>
        <div className="row" style={styles.hoursContainer}>
          <div style={styles.label}>+/- forbrug</div>
          <div style={[ styles.hours,
                        (overAllocation) < 0
                        && styles.danger]}>
              {renderOverAllocation(overAllocation)}
          </div>
        </div>
        <div className="row" style={styles.hoursContainer}>
          <div style={styles.updateDate}>{"Opdateret: " + simpleDate(lastUpdate)}</div>
          <div
            className="waves-btn"
            onClick={showBack}
            style={styles.flipCardButton}> Kontakt
              <i className="fa fa-chevron-right" style={styles.i} />
          </div>
        </div>
      </div>
    </div>
      );
    }
}

var styles = {
  body: {
    fontSize: '14px'
  },
  cardHeader: {
    height: '70px',
    lineHeight: 'normal',
    width:'100%',
    borderTopLeftRadius: '2px',
    borderTopRightRadius: '2px',
    borderBottomLeftRadius: '0px',
    borderBottomRightRadius: '0px',
    fontSize: '18px',
    fontWeight: 'bold',
    ':hover': {
      backgroundColor: semanticColors.primaryDark
    }
  },
  overAllocation:{
    borderLeftStyle: 'solid',
    borderLeftWidth: '10px',
    borderLeftColor: semanticColors.danger
  },
  outDated: {
    borderLeftStyle: 'solid',
    borderLeftWidth: '10px',
    borderLeftColor: semanticColors.warning
  },
  cardBody: {
    backgroundColor: semanticColors.default,
    textAlign: 'center',
    height: '240px',
    borderBottomLeftRadius: '2px',
    borderBottomRightRadius: '2px'
  },
  flipCardButton: {
    width: '90px',
    height: '35px',
    lineHeight: '35px',
    padding: '0px',
    float: 'right',
    fontWeight: '600',
    textAlign: 'center',
    cursor: 'pointer'
  },
  updateDate:{
    height: '35px',
    lineHeight: '35px',
    float: 'left',
    textAlign: 'left',
    fontWeight: '600',
    fontSize: '12px'
  },
  i: {
    marginLeft: '5px'
  },
  title : {
    color : semanticColors.default,
    fontWeight: 'bold',
    textDecoration: 'none'
  },
  defaultStar: {
    position: 'absolute',
    top: '0px',
    right: '0px',
    zIndex: '2',
    fontSize: '20px',
    color: semanticColors.default,
    cursor: 'pointer',
    width: '40px',
    height: '40px',
    lineHeight: '40px',
    textAlign: 'center'
  },
  hoursContainer: {
    paddingTop: '10px',
    paddingLeft: '12px',
    paddingRight: '12px'
  },
  hours : {
    fontSize: '24px',
    fontWeight: 'bold'
  },
  label: {
    fontSize: '14px',
    fontWeight: '600'
  },
  danger: {
    color: semanticColors.danger
  }
}
  FrontInsights.propTypes = {
    projectName: PropTypes.string.isRequired,
    projectNumber: PropTypes.string.isRequired,
    projectId: PropTypes.string.isRequired,
    client: PropTypes.string,
    favorite: PropTypes.bool.isRequired,
    insights: PropTypes.shape({
      estimatedSum: PropTypes.number,
      percent: PropTypes.float,
      totalHours: PropTypes.number,
      lastModified: PropTypes.string
    }),
    showBack: PropTypes.func.isRequired,
    updateFavorite: PropTypes.func.isRequired,
    overAllocation: PropTypes.number.isRequired,
    lastUpdate: PropTypes.instanceOf(Date),
    projectStatus: PropTypes.number
  };
export default Radium(FrontInsights);



// WEBPACK FOOTER //
// ./src/App/Project/Dashboard/ProjectCard/frontInsights.jsx